import SectionHeading from "@/components/base/SectionHeading";
import { testimonials } from "@/mocks/site";

export default function TestimonialsSection() {
  return (
    <section className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="读者与线人"
        title="他们这样描述这里"
        desc="来自读者、投递过的线人，以及同行从业者的真实反馈。"
      />

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
        {testimonials.map((t) => (
          <figure
            key={t.name}
            className="reveal flex flex-col rounded-lg border border-background-200 bg-background-50 p-6"
          >
            <i className="ri-double-quotes-l text-3xl text-accent-400" aria-hidden="true"></i>
            <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{t.text}</blockquote>
            <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-5">
              <span className="h-11 w-11 overflow-hidden rounded-full bg-background-200">
                <img
                  src={t.avatar}
                  alt={`${t.name} 头像`}
                  title={t.name}
                  className="h-full w-full object-cover object-top"
                />
              </span>
              <span>
                <span className="block font-label text-sm font-semibold text-foreground-900">{t.name}</span>
                <span className="block text-xs font-label text-foreground-500">{t.role}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}